import {
    SeasonResponse,
    SeasonMappedResult,
    SeasonMapped
  } from '@/core/interfaces';

  export const SeasonMapper = (season: SeasonResponse): SeasonMappedResult => {
    const mappedSeason: SeasonMapped = {
      id: season.id,
      name: season.name,
      startDate: season.start_time,
      endDate: season.end_time,
      isActive: season.is_active === 1,
      createdAt: season.created_at,
    };
  
    return { seasons: [mappedSeason] };
  };